import { createFileRoute, Link } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { Button } from "../components/ui";
import { MascotArt } from "../components/MascotArt";
import { useBillingSync } from "../lib/useBillingSync";

export const Route = createFileRoute("/billing/success")({
  component: BillingSuccess,
});

function BillingSuccess() {
  // Polls the entitlement until the payment's webhook has landed.
  const { status, sub } = useBillingSync({ always: true });
  const balance = sub.data?.credits.balance;

  return (
    <div className="mx-auto flex min-h-[calc(100dvh-10rem)] max-w-md items-center px-4 py-10">
      <div className="tactile w-full p-8 text-center">
        <MascotArt
          pose="celebrating"
          className="mx-auto size-32 animate-pop-in"
        />
        <h1 className="mt-3 text-3xl text-ink">Payment complete</h1>
        <p
          className="mx-auto mt-2 max-w-sm text-sm font-semibold text-ink-soft"
          aria-live="polite"
        >
          {status === "waiting" ? (
            <span className="inline-flex items-center gap-2">
              <Loader2 className="size-4 animate-spin" aria-hidden="true" />
              Confirming your payment…
            </span>
          ) : status === "updated" && balance !== undefined ? (
            `You're all set — you now have ${balance} credit${balance === 1 ? "" : "s"}.`
          ) : (
            "Your purchase is being synced. Your plan and credits may take a moment to update after the payment provider confirms the payment."
          )}
        </p>
        <div className="mt-7 flex flex-col justify-center gap-3 sm:flex-row">
          <Button render={<Link to="/" />}>Start drawing</Button>
          <Button variant="outline" render={<Link to="/settings/billing" />}>
            Back to settings
          </Button>
        </div>
      </div>
    </div>
  );
}
